import { getCustomerByExternalReference, } from "../services/getCustomerByExternalReference.js";
import { updateCustomer } from "../services/updateCustomer.js";
import { mergeCustomerImportData } from "../utils/mergeCustomerImportData.js";
import Logger from "@cappelendamm/logger";
import { sanitizePhoneNumber } from "../utils/sanitize-phone-number.js";
import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../index.js";
/**
 * Look up existing customer by phone; if found, merge and update new import metadata/external references.
 * @param customerInput Incoming customer data (phone used for lookup; metadata may be merged)
 * @param client Crystallize client instance
 * @returns Existing customer identifier or null if not found
 */
export async function getExistingCustomer(customerInput, { client }) {
    let customer;
    const trimmedPhone = customerInput.phone?.trim();
    if (trimmedPhone) {
        customer = await getCustomerByExternalReference({
            key: CUSTOMER_EXTERNAL_REFERENCE_KEY.PHONE,
            value: sanitizePhoneNumber(trimmedPhone),
        }, { client });
    }
    if (customer?.identifier) {
        Logger.log(`Customer with identifier ${customer.identifier} already exists. Skipping creation of new customer.`);
        // Try to merge new metadata and external references that don't already exist
        const updateData = mergeCustomerImportData(customer, customerInput);
        if (updateData) {
            Logger.log(`Updating customer ${customer.identifier} with new metadata and external references from import.`);
            await updateCustomer(updateData, customer.identifier, { client });
        }
        return customer.identifier;
    }
    return null;
}
